import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getDriverDutyLogs as getDriverDutyLogsAction, clearDriverDutyLogs as clearDriverDutyLogsAction } from 'actions/driverDutyLogs';

const useDriverDutyLogs = () => {
  const dispatch = useDispatch();

  const getDriverDutyLogs = useCallback(({offset, query, limit}) => dispatch(getDriverDutyLogsAction({offset, query, limit})), [dispatch]);
  const clearDriverDutyLogs = useCallback(() => dispatch(clearDriverDutyLogsAction()), [dispatch]);

  return { getDriverDutyLogs, clearDriverDutyLogs };
};

export default useDriverDutyLogs; 